import AssignmentHistory from "./AssignmentHistory";

export default AssignmentHistory;
